module.exports = __webpack_public_path__ + "img/apps_19.a419dc72.jpg";